module.exports = __webpack_public_path__ + "assets/img/5.568d5eb4.jpg";